import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PropertiesAddComponent } from './properties-add/properties-add.component';
import { PropertiesStatsComponent } from './properties-stats/properties-stats.component';
import { PropertiesComponent } from './properties/properties.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbdModalModule } from '../modal/modal.module';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { PipesModule } from '../pipes/pipes.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { SharedComponentsModule } from '../shared-components-module/shared-components.module';
import { RouterModule, Routes } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';
import { PropertiesEditComponent } from './properties-edit/properties-edit.component';
import { PaymentModule } from '../shared-components-module/payments/payment.module';

const routes: Routes = [
  {path: 'properties', component: PropertiesComponent},
  {path: 'properties/new', component: PropertiesAddComponent},
  {path: 'properties/new/:client', component: PropertiesAddComponent},
  {path: 'properties/edit/:prop/:client', component: PropertiesEditComponent},
  {path: 'properties/stats/:prop/:client', component: PropertiesStatsComponent},
];


@NgModule({
  declarations: [
    PropertiesComponent,
    PropertiesAddComponent,
    PropertiesStatsComponent,
    PropertiesEditComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbModule,
    NgbdModalModule,
    AngularEditorModule,
    PipesModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    SharedComponentsModule,
    RouterModule.forRoot(routes),
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
      preventDuplicates: false,
    }), // ToastrModule added
    PaymentModule,
    NgbNavModule
  ]
})
export class PropertyModule { }
